import { render } from "./ProjectDocumentationView.vue?vue&type=template&id=7e9fc4bb"
import script from "./ProjectDocumentationView.vue?vue&type=script&lang=js"
export * from "./ProjectDocumentationView.vue?vue&type=script&lang=js"

import "./ProjectDocumentationView.vue?vue&type=style&index=0&id=7e9fc4bb&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__